module.exports = __webpack_public_path__ + "img/icon_back_bottom.656f23b4.svg";